import { DateFieldRhf } from '@xemplo/date-field';

import * as S from '../../modal.styles';

export function EffectiveDate() {
  return (
    <S.FormLabel>
      Pay Run Generation Date
      <DateFieldRhf
        name="adhocEffectiveDate"
        aria-label="Pay Run Generation Date"
        placeholder="Select date"
        rules={{ required: 'This field is required' }}
        dateFormat="DD/MM/YYYY"
      />
    </S.FormLabel>
  );
}
